import Component from "../Component";
import $ from "jquery";
import * as autocomplete from "~/autocomplete";
import { extractBirth, validateCodiceFiscale } from "~/utils/codicefiscale";
import { DeleteDocumentoGara, uploadDocumentoGara } from '~/services/documentService';
import "../../globals";
import * as validation from "~/utils/validation";
import { format } from "date-fns";
import * as _ from "~/utils";

import UI from "~/ui";
import { getApi } from "~/auth";
import * as bootstrap from "bootstrap";
import { t } from "~/hooks/useI18n";

import {
    SoggettoFisico,
    SoggettoGiuridico,
    ModalitaAcquisto,
    TipoPersona,
    SoggettoBase
} from "./SoggettoVenditaAcquistoModal.models";

// ✅ Importa utility validazione file
import {
    ALLOWED_FILE_EXTENSIONS,
    validateAndShowFileError,
    formatFileSize,
    showFileError,
    clearFileError,
    showCustomFileError,
    clearCustomFileError,
    validateMaskedFileInputWithBorder
} from "~/utils/fileValidation";

export class SoggettoVenditaAcquistoModal extends Component {
    private theForm: HTMLFormElement = document.getElementById("frmSoggettoVenditaAcquisto") as HTMLFormElement;
    private modalSoggetto: HTMLElement = document.getElementById("modalSoggettoVenditaAcquisto") as HTMLElement;
    private _eventsRegistered: boolean = false; //evita la registrazione multipla degli eventi sulla stessa istanza della modale
    private onSuccessCallback: (() => void) | null = null;
    private auth: any = null;
    private userinfo: any;
    private soggetto: any = null;
    private _modalitaAcquisto: string | null = null;
    private offertaId: any = 0;
    private idAstaTelematica: any = 0;
    //private contatore: number = 0;

    constructor(containerId: string, formId: string) {
        super(containerId);
        this.theForm = document.getElementById(formId) as HTMLFormElement;
        if (!this.theForm) {
            console.error(`Form con ID '${formId}' non trovato.`);
        }
    }

    public setOnSuccessCallback(callback: () => void): void {
        this.onSuccessCallback = callback;
    }

    public async activate(soggettoData?: any): Promise<void> {
        const that = this;

        this.auth = getApi();
        this.userinfo = this.auth.getCached("userInfo");
        if (!this.userinfo || !this.userinfo.isAuthenticated) {
            UI.confirmOneButton("", t("messages.UtenteNonAutorizzato"));
            return;
        }


        if (!this.modalSoggetto) {
            console.error("Modal 'modalSoggettoVenditaAcquisto' non trovato");
            return;
        }

        if (!this.theForm) {
            console.error("Form #frmSoggettoVenditaAcquisto non trovato");
            return;
        }

        // Reset campi del form
        this.resetForm(this.theForm);

        //in caso di modifica popolo la modale
        if (soggettoData) {
            console.info("Sono dentro Activate--> con soggettoData");
            this.soggetto = soggettoData;
        }

        // Inizializza eventi della modale
        this.initializeModalEvents(this.modalSoggetto);

        // Inizializza autocomplete
        this.initializeAutocomplete();

        // Aggiungi validazione
        this.addValidation();

        if (!this._eventsRegistered) {
            // Registra gli event handlers
            this.registerEventHandlers();
            this._eventsRegistered = true;
            // Configura pulsante Salva
            const btnSaveCompr = $(this.domElement).find("#btnSalvaSoggettoVenditaAcquisto");
            if (btnSaveCompr.length === 0) {
                console.error("Pulsante salva SoggettoVenditaAcquisto non trovato");
                return;
            }

            btnSaveCompr.on("click", (event) => {
                event.preventDefault();
                this.handleFormSubmit();
                return false;
            });
        }

        return Promise.resolve();
    }

    private resetForm(formElement: HTMLElement | HTMLFormElement): void {
        // Svuota tutti i campi input, select, textarea (esclusi radio)
        formElement.querySelectorAll("input, select, textarea").forEach((el) => {
            if (el instanceof HTMLInputElement || el instanceof HTMLSelectElement || el instanceof HTMLTextAreaElement) {
                if (el.type !== "radio") {
                    el.value = "";
                }
                el.classList.remove("is-invalid", "is-valid");
            }
        });

        // Se è un form, resetta anche la validazione HTML5 e le classi
        if (formElement instanceof HTMLFormElement) {
            formElement.reset();
            formElement.classList.remove("was-validated");
        }

        // Nasconde tutti i messaggi di errore
        formElement.querySelectorAll(".invalid-feedback").forEach((feedback) => {
            feedback.classList.add("d-none");
        });

        // Rimuove classi di errore dagli input
        formElement.querySelectorAll(".is-invalid, .is-valid").forEach((input) => {
            input.classList.remove("is-invalid", "is-valid");
        });
    }

    private popolaCampiSoggettoVenditaAcquistoModal(soggetto: any): void {
        // Popola i campi della modale con soggettoData
        //console.info("Popolazione campi soggetto vendita acquisto modal --> ", soggetto);
        $("#SoggettoId").val(soggetto.Id);

        // Imposta il radio corretto in base al valore di soggetto.PersonaGiuridica
        if (soggetto.PersonaGiuridica) {
            $("#SoggettoPersonaGiuridica").prop("checked", true);
            $("#SoggettoPersonaFisica").prop("checked", false);
        } else {
            $("#SoggettoPersonaFisica").prop("checked", true);
            $("#SoggettoPersonaGiuridica").prop("checked", false);
        }

        $("#SoggettoQuota").val(soggetto.QuotaComproprieta);

        $("#SoggettoNome").val(soggetto.Nome);
        $("#SoggettoCognome").val(soggetto.Cognome);
        $("#SoggettoDenominazione").val(soggetto.Denominazione);
        $("#SoggettoCodiceFiscale").val(soggetto.CodiceFiscale);
        $("#SoggettoPartitaIva").val(soggetto.PartitaIva);
        if (soggetto.DataNascita) {
            // Estrae solo la parte della data (YYYY-MM-DD)
            const [anno, mese, giorno] = soggetto.DataNascita.substring(0, 10).split("-");
            $("#SoggettoDataNascita").val(`${anno}-${mese}-${giorno}`);
        }
        $("#SoggettoIdStatoNascita").val(soggetto.IdStatoNascita);
        if (soggetto.IdStatoNascita == 100) {
            $("#SoggettoIdComuneNascita").val(soggetto.IdComuneNascita);
            $("#txtComuneNascitaCompr").val(soggetto.ComuneNascita);
            $("#hidden-soggetto-nascita-ita").addClass("d-none");
            $("#hidden-soggetto-nascita-estero").removeClass("d-none");
        } else {
            $("#SoggettoLuogoNascitaEstero").val(soggetto.LuogoNascitaEstero);
            $("#hidden-soggetto-nascita-estero").addClass("d-none");
            $("#hidden-soggetto-nascita-ita").removeClass("d-none");
        }


        $("#SoggettoEmail").val(soggetto.Email);
        $("#SoggettoPec").val(soggetto.Pec);
        $("#SoggettoTelefono").val(soggetto.Telefono);
        $("#SoggettoCodiceSdi").val(soggetto.CodiceSdi);

        $("#SoggettoIdStatoResidenza").val(soggetto.IdStatoResidenza);
        $("#SoggettoIndirizzoResidenza").val(soggetto.IndirizzoResidenza);
        if (soggetto.IdStatoResidenza == 100) {
            $("#SoggettoIdComuneResidenza").val(soggetto.IdComuneResidenza);
            $("#txtComuneCompr").val(soggetto.ComuneResidenza);
            $("#SoggettoCapResidenza").val(soggetto.CapResidenza);
            $("#SoggettoIdProvinciaResidenza").val(soggetto.IdProvinciaResidenza);
            $("#txtProvinciaCompr").val(soggetto.ProvinciaResidenza);
            $(".hidden-soggetto-residenza-estero").removeClass("d-none");
            $(".hidden-soggetto-residenza-ita").addClass("d-none");
        } else {
            $("#SoggettoLuogoResidenzaEstero").val(soggetto.LuogoResidenzaEstero);
            $(".hidden-soggetto-residenza-estero").addClass("d-none");
            $(".hidden-soggetto-residenza-ita").removeClass("d-none");
        }



        $("#SoggettoTipoDocumento").val(soggetto.TipoDocumento);

        // Dopo aver popolato i campi della modale
        if (soggetto.AllegatoGaraId) {
            console.log("Soggetto presente con allegato gara id: ", soggetto.AllegatoGaraId);
            $("#btnEliminaDocSoggetto").attr("data-id", soggetto.AllegatoGaraId);
        }
        else {
            console.log("Allegato Soggetto NON presente: ");
        }
        if (soggetto.AllegatoGara) {
            console.log("Soggetto presente con allegato gara: ", soggetto.AllegatoGara);
            const nomeFile = soggetto.AllegatoGara.Descrizione;
            const urlFile = "/Asta/ScaricaDocumentoGara?data=" + soggetto.AllegatoGara.Path + "&nomeDoc=" + soggetto.AllegatoGara.Descrizione;

            $("#lblNomeFileDocumento")
                .text(nomeFile)
                .attr("href", urlFile);
        } else {
            console.log("Allegato Soggetto NON presente: ");
        }
    }

    /**
     * Popola i campi nascosti del form
     * @param modalCompr
     */
    private impostaHiddenFieldsModal(modalCompr: HTMLElement): void {
        this._modalitaAcquisto = modalCompr.getAttribute("data-modalita-acquisto");
        $("#SoggettoIdModalitaPartecipazione").val(this._modalitaAcquisto as string);
        $("#SoggettoIdVendita").val(modalCompr.getAttribute("data-vendita-id") as string);
        $("#SoggettoOffertaId").val(modalCompr.getAttribute("data-offerta-id") as string);
        $("#SoggettoBustaId").val(modalCompr.getAttribute("data-busta-id") as string);
        $("#SoggettoPraticaId").val(modalCompr.getAttribute("data-pratica-id") as string);
        $("#SoggettoIdAstaTelematica").val(modalCompr.getAttribute("data-astatelematica-id") as string);
    }

    private initializeModalEvents(modalSoggetto: HTMLElement): void {
        const that = this;
        const titoliModalita: Record<string, string> = {
            "2": t("common.DatiSocietaEnte"),
            "3": t("common.DatiPersonaFisicaGiuridica"),
            "4": t("common.DatiContitolare"),
            "6": t("common.DatiSoggettoAmministrato"),
        }; // TODO: i18n


        $(modalSoggetto).off("show.bs.modal");
        $(modalSoggetto).on("show.bs.modal", (e) => {
            if ($((e as any).relatedTarget).hasClass('btnAggiungiSoggetto')) {
                this.soggetto = null;
                //***************************************************************************************** */
                // Reset di tutti i campi input, textarea e select ad eccezione delle checkbox e radio button
                //***************************************************************************************** */
                $("#frmSoggettoVenditaAcquisto")
                    .find('input:not([type="checkbox"]):not([type="radio"]), textarea, select')
                    .val('');
                // Reset dei radio button e checkbox
                $("#frmSoggettoVenditaAcquisto").find('input[type="radio"], input[type="checkbox"]').prop('checked', false);
                // Nascondi eventuali alert o messaggi
                $("#frmSoggettoVenditaAcquisto").find('.alert').addClass('d-none');

            }

            this.impostaHiddenFieldsModal(modalSoggetto);

            //imposta il titolo
            if (this._modalitaAcquisto !== null && this._modalitaAcquisto !== undefined) {
                const titolo = titoliModalita[this._modalitaAcquisto] || t("common.DatiSoggetto");
                $("#SoggettiVenditaAcquistoLabel").text(titolo);
            } else {
                $("#SoggettiVenditaAcquistoLabel").text(t("common.DatiSoggetto"));
            }


            let soggettoAcquisto: SoggettoBase = this.creaSoggettoPerModalita(this._modalitaAcquisto);
            let isGiuridica: boolean = false;
            let isResidenzaEstero: boolean = false;
            let isStatoNascitaEstero: boolean = false;
            let existAllegatoGaraId: boolean = false;
            let isUpdate: boolean = false;

            const isTutore = soggettoAcquisto.modalitaAcquisto === ModalitaAcquisto.DaTutore;
            const isComproprietario = soggettoAcquisto.modalitaAcquisto === ModalitaAcquisto.InComproprieta;

            if (typeof this.soggetto !== "undefined" && this.soggetto !== null) {
                isUpdate = true;
                isGiuridica = !!this.soggetto.PersonaGiuridica;
                isResidenzaEstero = this.soggetto.IdStatoResidenza != 100;
                isStatoNascitaEstero = this.soggetto.IdStatoNascita != 100;

                soggettoAcquisto.tipoPersona = isGiuridica ? TipoPersona.Giuridica : TipoPersona.Fisica;
                soggettoAcquisto.statoResidenza = isResidenzaEstero ? "estero" : "ita";
                soggettoAcquisto.luogoNascita = isStatoNascitaEstero ? "estero" : "ita";


                if (this.soggetto.AllegatoGaraId && parseInt(this.soggetto.AllegatoGaraId) > 0) {
                    existAllegatoGaraId = true;
                }
                this.popolaCampiSoggettoVenditaAcquistoModal(this.soggetto);
            } else {
                // Esempio di utilizzo nel codice selezionato:
                const soggettoAcquisto = this.creaSoggettoPerModalita(this._modalitaAcquisto);
                isGiuridica = soggettoAcquisto.tipoPersona === "giuridica";

            }

            const label = $('label[for="SoggettoCodiceFiscale"]');
            const baseText = label.text().replace(/\s*\*\*?$/, ''); // Rimuove eventuali * o **
            if (isGiuridica) {
                label.html(baseText + ' **');
                // ✅ Per persona giuridica: rimuovi required da CF e P.IVA
                $("#SoggettoCodiceFiscale").removeAttr("required");
                $("#SoggettoPartitaIva").removeAttr("required");
            } else {
                label.html(baseText + ' *');
                // ✅ Per persona fisica: CF obbligatorio
                $("#SoggettoCodiceFiscale").attr("required", "required");
                $("#SoggettoPartitaIva").removeAttr("required");
            }

            $("#SoggettoPersonaFisica").prop("checked", !isGiuridica);
            $("#SoggettoPersonaGiuridica").prop("checked", isGiuridica);

            // Gestione visibilità switch persona giuridica
            // Visibile solo per modalità 3 (Per Procura) e 4 (In Comproprietà)
            $("#divSwitchPersonaGiuridica").toggleClass("d-none",
                (this._modalitaAcquisto !== "3" && this._modalitaAcquisto !== "4")
            );

            $("#divQuota").toggleClass("d-none", !isComproprietario);
            $("#SoggettoQuota").prop("required", isComproprietario);

            // Gestione visibilità intestazioni
            $("#h2Residenza").toggleClass("d-none", isGiuridica);
            $("#h2SedeLegale").toggleClass("d-none", !isGiuridica);

            that.setPersona(soggettoAcquisto.tipoPersona);
            that.setResidenza(soggettoAcquisto.statoResidenza);
            // 2️⃣ setNascita DOPO setPersona: sovrascrive correttamente il required sul comune
            if (!isGiuridica)
                that.setNascita(soggettoAcquisto.luogoNascita);
            else
                that.setNascita(null);

            if (soggettoAcquisto.modalitaAcquisto == "InComproprieta" && soggettoAcquisto.tipoPersona == "giuridica") {

                that.setDocumento("PerSocieta");
            } else {
                that.setDocumento(soggettoAcquisto.modalitaAcquisto);
            }

            $(".hidden-soggetto-update").toggleClass("d-none", existAllegatoGaraId);

            // ✅ Se l'allegato non è presente, i campi devono essere required
            if (!existAllegatoGaraId) {
                $("#SoggettoFileDocumento").prop("required", true);
                $("#SoggettoTipoDocumento").prop("required", true);
            } else {
                $("#SoggettoFileDocumento").prop("required", false);
                $("#SoggettoTipoDocumento").prop("required", false);
            }

            $(".hidden-soggetto-insert").toggleClass("d-none", !existAllegatoGaraId);
        });

        // ✅ Pulizia del form quando la modale viene chiusa
        $(modalSoggetto).off("hidden.bs.modal");
        $(modalSoggetto).on("hidden.bs.modal", () => {
            // Reset del form e rimozione delle classi di validazione
            this.resetForm(this.theForm);
            // Rimuovi il messaggio custom per persona giuridica
            $("#cf-piva-required").remove();
            // Rimuovi la classe was-validated dal form
            this.theForm.classList.remove("was-validated");
        });

    }

    private creaSoggettoPerModalita(modalita: string | null): SoggettoBase {
        switch (modalita) {
            case "2":
                return new SoggettoGiuridico(ModalitaAcquisto.PerSocieta);
            case "3":
                return new SoggettoFisico(ModalitaAcquisto.PerProcura);
            case "4":
                return new SoggettoFisico(ModalitaAcquisto.InComproprieta);
            case "6":
                return new SoggettoFisico(ModalitaAcquisto.DaTutore);
            default:
                throw new Error(t("messages.modalitaAcquistoNonGestita"));
        }
    }

    private initializeAutocomplete(): void {

        autocomplete.autoCompleteComuni(
            true,
            "txtComuneNascitaCompr",
            "SoggettoIdComuneNascita",
            null,
            null,
            null
        );

        autocomplete.autoCompleteComuni(
            false,
            "txtComuneCompr",
            "SoggettoIdComuneResidenza",
            "SoggettoIdProvinciaResidenza",
            "txtProvinciaCompr",
            "SoggettoCapResidenza"
        );

    }

    private registerEventHandlers(): void {
        const that = this;
        // resetto i campi sull'edit del comune
        $("#txtComuneCompr").on('keyup', function () {
            $("#SoggettoIdComuneResidenza").val("");
            $("#SoggettoIdProvinciaResidenza").val("");
            $("#txtProvinciaCompr").val("");
            $("#SoggettoCapResidenza").val("");
            const value = $(this).val();
            if (value) {
                $("#txtComuneCompr").removeClass("is-invalid");
                $("#txtComuneCompr").siblings(".invalid-feedback").addClass("d-none").removeClass("d-block");
                $("#SoggettoCapResidenza").removeClass("is-invalid");
                $("#SoggettoCapResidenza").siblings(".invalid-feedback").addClass("d-none").removeClass("d-block");
            }
        });

        // ✅ Resetta il campo nascosto quando l'utente modifica il testo del comune di nascita
        $("#txtComuneNascitaCompr").on('keyup', function () {
            $("#SoggettoIdComuneNascita").val("");
            const value = $(this).val();
            if (value) {
                $("#txtComuneNascitaCompr").removeClass("is-invalid");
                $("#txtComuneNascitaCompr").siblings(".invalid-feedback").addClass("d-none").removeClass("d-block");
            }
        });

        // ✅ Rimuovi l'errore dal campo comune di nascita quando viene popolato il campo nascosto
        //$("#txtComuneNascitaCompr").on('change', function () {
        //    const value = $(this).val();
        //    if (value) {
        //        $("#txtComuneNascitaCompr").removeClass("is-invalid");
        //        $("#txtComuneNascitaCompr").siblings(".invalid-feedback").addClass("d-none").removeClass("d-block");
        //    }
        //});

        // ✅ Rimuovi l'errore dal campo comune di residenza quando viene popolato il campo nascosto
        //$("#txtComuneCompr").on('change', function () {
        //    const value = $(this).val();
        //    if (value) {
        //        $("#txtComuneCompr").removeClass("is-invalid");
        //        $("#txtComuneCompr").siblings(".invalid-feedback").addClass("d-none").removeClass("d-block");
        //    }
        //});

        // Campo Codice Fiscale in uppercase + pulizia errore formato
        $("#SoggettoCodiceFiscale").on("keyup", function () {
            const cf = $(this).val() as string;
            $(this).val(cf.toUpperCase());
            // ✅ Rimuovi l'errore di formato mentre l'utente digita
            $(this).removeClass("is-invalid");
            $("#cf-format-error").remove();
        });

        $("#SoggettoCodiceFiscale").on("blur", function () {
            const cf = $(this).val() as string;
            //const isPersonaGiuridica = $('input[name="PersonaGiuridica"]').val() === "true";
            const isPersonaGiuridica = $('input[name="PersonaGiuridica"]:checked').val() === "true";
            if (cf && !isPersonaGiuridica)
                that.aggiornaDatiDaCodiceFiscale(cf);
        });

        // Stato nascita
        $("#SoggettoIdStatoNascita").on("change", function () {
            const idStato = _.coalesce($(this).val(), "") as string;
            that.setNascita(idStato !== "100" ? "estero" : "ita");
        });

        // Stato residenza
        $("#SoggettoIdStatoResidenza").on("change", function () {
            const idStato = _.coalesce($(this).val(), "") as string;
            that.setResidenza(idStato !== "100" ? "estero" : "ita");
        });

        // Switch Persona Giuridica
        $('input[name="PersonaGiuridica"]').on("change", function () {
            const isPersonaGiuridica = $(this).val() === "true";
            const optToDisplay = isPersonaGiuridica ? "giuridica" : "fisica";

            that.setPersona(optToDisplay);  // 1️⃣ imposta campi per tipo persona

            // Riallinea la visibilità/required del comune di nascita
            // in base allo stato di nascita correntemente selezionato
            if (!isPersonaGiuridica) {
                const idStatoNascita = $("#SoggettoIdStatoNascita").val() as string;
                const luogoNascita = idStatoNascita && idStatoNascita !== "100" ? "estero" : "ita";
                that.setNascita(luogoNascita);
            } else {
                that.setNascita(null); // persona giuridica: nessun dato di nascita
            }

            $("#h2Residenza").toggleClass("d-none", isPersonaGiuridica);
            $("#h2SedeLegale").toggleClass("d-none", !isPersonaGiuridica);

            const label = $('label[for="SoggettoCodiceFiscale"]');
            const baseText = label.text().replace(/\s*\*\*?$/, '');

            if (isPersonaGiuridica) {
                label.html(baseText + ' **');
                if (that._modalitaAcquisto == "4")
                    that.setDocumento("PerSocieta");
                $("#SoggettoCodiceFiscale").removeAttr("required");
                $("#SoggettoPartitaIva").removeAttr("required");
            } else {
                label.html(baseText + ' *');
                that.setDocumento("InComproprieta");
                $("#SoggettoCodiceFiscale").attr("required", "required");
                $("#SoggettoPartitaIva").removeAttr("required");
            }
        });

        // ✅ Validazione file al momento della selezione
        $("#SoggettoFileDocumento").on("change", function () {

            const fileInput = this as HTMLInputElement;
            if (fileInput.files && fileInput.files.length > 0) {
                validateAndShowFileError(fileInput, fileInput.files[0]);
            }
        });

        $(".delete-doc-soggetto").on("click", async function (e) {
            e.preventDefault();
            const docId = $(this).data("id");
            const soggettoIdValue = $("#SoggettoId").val();
            const soggettoId = soggettoIdValue ? parseInt(soggettoIdValue as string, 10) : null;
            const tipoPersona = $("#SoggettoPersonaGiuridica").is(":checked") ? "giuridica" : "fisica";
            const modalitaAcquisto = $("#SoggettoIdModalitaPartecipazione").val();

            if (!docId || !soggettoId || isNaN(soggettoId)) return;

            // ✅ Nasconde la modale del soggetto prima di mostrare l'alert
            const modalElement = document.getElementById('modalSoggettoVenditaAcquisto') as HTMLDivElement;
            const modalInstance = bootstrap.Modal.getInstance(modalElement);
            if (modalInstance) {
                modalInstance.hide();
            }

            UI.confirm(t("common.confirm"), t("messages.confirmDelete"), "", async (result) => {

                if (!result) {
                    // ✅ Riapre la modale se l'utente annulla
                    if (modalInstance) {
                        modalInstance.show();
                    }
                    return;
                }

                await DeleteDocumentoGara(docId);

                //Aggiorno il record del soggetto togliendo l'id dell'allegato
                if (soggettoId) {
                    await that.resetAllegatoGaraid(soggettoId);
                }

                // ✅ Riapre la modale dopo aver eliminato il documento
                if (modalInstance) {
                    modalInstance.show();
                }

                //aggiorno l'interfaccia
                $(".hidden-soggetto-insert").addClass("d-none");
                $(".hidden-soggetto-update").removeClass("d-none");
                $("#SoggettoTipoDocumento").attr("required", "required");
                $("#SoggettoFileDocumento").attr("required", "required");

            });

        });

        $(document).on("click", ".delete-soggetto", async (e) => {
            console.log("Ho richiamato la delete-soggetto da soggettovenidta.ts");
            e.preventDefault();
            const el = $(e.target).closest(".delete-soggetto")[0];
            if (!el) return;
            const idSoggetto = el.getAttribute("data-id");
            if (!idSoggetto) {
                console.error("ID del soggetto non trovato");
                return;
            }

            UI.confirm(t("common.confirm"), t("messages.confirmDelete"), "", async (result) => {

                if (!result) {
                    return;
                }

                await this.deleteSoggettoVenditaAcquisto(parseInt(idSoggetto));

                if (el && el.closest) {
                    el.closest(".soggetto-item")?.remove();
                }

                // ✅ Triggera l'evento dopo aver rimosso dalla UI
                $(document).trigger("soggettoEliminato");

            });
        })

        $(document).on("click", ".update-soggetto", async (e) => {
            e.preventDefault();
            // Recupera il bottone cliccato, anche se il click è su un'icona interna
            const el = $(e.target).closest(".update-soggetto")[0];
            if (!el) return;
            const soggettoId = el.getAttribute("data-id");
            const modalitaId = el.getAttribute("data-modalitaid");

            if (!soggettoId || !modalitaId) return;

            var url = window.BaseUrlWebApi + "SoggettoVenditaAcquisto/Get?id=" + soggettoId;
            this.soggetto = await this.auth.fetchWithAuth("GET " + url, {
                cache: "no-cache",
                headers: { 'content-type': 'application/json' },
            });

            if (!this.soggetto) {
                UI.confirmOneButton("", t("messages.erroreRecuperoDatiSoggetto"));
                return;
            }

            $("#modalSoggettoVenditaAcquisto").modal("show");
        })
    }

    private setPersona(opt: "fisica" | "giuridica") {
        this.setFildForm("persona", opt);
    }

    private setFildForm(categ: "persona", optToDisplay: "fisica" | "giuridica"): void {
        const optToHide = (optToDisplay === "fisica") ? "giuridica" : "fisica";

        $(`.hidden-soggetto-${categ}-${optToHide} :input`).removeAttr('disabled');

        this.theForm.classList.toggle(`${categ}-${optToDisplay}`, true);
        this.theForm.classList.toggle(`${categ}-${optToHide}`, false);

        $(`.hidden-soggetto-${categ}-${optToDisplay} :input`)
            .val("")
            .prop('disabled', true)
            .removeAttr("required"); // resetto i campi nascosti

        // ✅ Aggiunge required ai campi visibili, MA esclude i campi del comune di nascita
        // perché il loro required è gestito esclusivamente da setNascita()
        const NASCITA_IDS = ["txtComuneNascitaCompr", "SoggettoIdComuneNascita", "SoggettoLuogoNascitaEstero"];
        $(`.hidden-soggetto-${categ}-${optToHide} :input`).each(function () {
            const id = $(this).attr("id") || "";
            if (!NASCITA_IDS.includes(id)) {
                $(this).attr('required', "required");
            }
        });

        $(`.hidden-soggetto-${categ}-${optToDisplay}`).addClass("d-none");
        $(`.hidden-soggetto-${categ}-${optToHide}`).removeClass("d-none");
    }

    private setResidenza(opt: "ita" | "estero") {
        this.setStato("residenza", opt);
        if (opt === "ita") {
            $("#SoggettoIdStatoResidenza").val(100);
            $("#SoggettoLuogoResidenzaEstero").removeAttr("required");
            $("#txtComuneCompr").attr('required', "required");
            $("#SoggettoIdComuneResidenza").attr('required', "required");
            $("#SoggettoCapResidenza").attr('required', "required");
        }
        else {
            $("#SoggettoLuogoResidenzaEstero").attr('required', "required");
            $("#txtComuneCompr").removeAttr('required');
            $("#SoggettoIdComuneResidenza").removeAttr('required');
            $("#SoggettoCapResidenza").removeAttr('required');
        }
    }

    private setNascita(opt: "ita" | "estero" | null) {
        if (opt) {
            this.setStato("nascita", opt);
            if (opt === "ita") {
                $("#SoggettoIdStatoNascita").val(100);
                $("#txtComuneNascitaCompr").attr('required', "required");
                $("#SoggettoIdComuneNascita").attr('required', "required");
            } else if (opt === "estero") {
                $("#txtComuneNascitaCompr").removeAttr('required');
                $("#SoggettoIdComuneNascita").removeAttr('required');
                $("#SoggettoLuogoNascitaEstero").attr('required', "required");
            }
        }
        else {
            $("#txtComuneNascitaCompr").removeAttr('required');
            $("#SoggettoIdComuneNascita").removeAttr('required');
            $("#SoggettoLuogoNascitaEstero").removeAttr('required');
        }
    }

    private setStato(categ: "cittadinanza" | "residenza" | "nascita", optToDisplay: "ita" | "estero") {
        const optToHide = (optToDisplay === "ita") ? "estero" : "ita";

        $(`.hidden-soggetto-${categ}-${optToHide} :input`).removeAttr('disabled');

        this.theForm.classList.toggle(`${categ}-${optToDisplay}`, true);
        this.theForm.classList.toggle(`${categ}-${optToHide}`, false);

        $(`.hidden-soggetto-${categ}-${optToDisplay} :input`)
            .val("")
            .prop('disabled', true); // resetto i campi nascosti

        $(`.hidden-soggetto-${categ}-${optToDisplay}`).addClass("d-none");
        $(`.hidden-soggetto-${categ}-${optToHide}`).removeClass("d-none");

    }

    private setDocumento(opt: "PerSocieta" | "PerProcura" | "InComproprieta" | "DaTutore"): void {
        this.aggiornaOpzioniTipoDocumento(opt)
    }

    private aggiornaOpzioniTipoDocumento(modalitaAcquisto: string): void {
        console.log("aggiornaOpzioniTipoDocumento", modalitaAcquisto);
        const ddlTipoDocumento = $("#SoggettoTipoDocumento");

        // Nascondi tutte le opzioni
        ddlTipoDocumento.find("option").hide();


        // Mostra solo le opzioni con la classe corrispondente alla modalità di acquisto
        ddlTipoDocumento.find(`option.${modalitaAcquisto}`).show();

        // Resetta il valore della select
        ddlTipoDocumento.val("");
    }

    private addValidation(): void {
        const form = this.theForm;

        // Rimuove la classe di validazione quando l'utente modifica i campi
        form.addEventListener("input", () => {
            form.classList.remove("was-validated");
        });

        // ✅ Validatore per email
        const emailValidator = (inputElement: HTMLInputElement): validation.ValidationResult => {
            if (!$(inputElement).is(":visible") || $(inputElement).is(":disabled")) {
                return { ok: true, error: "" };
            }

            const inputValue = $(inputElement).val() as string;

            // Se il campo è vuoto e non è required, passa
            if (!inputValue && !$(inputElement).prop("required")) {
                return { ok: true, error: "" };
            }

            // Se è richiesto e vuoto
            if (!inputValue && $(inputElement).prop("required")) {
                return { ok: false, error: t("validation.required") };
            }

            // ✅ Validazione formato email
            const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
            const isValid = emailRegex.test(inputValue);

            return {
                ok: isValid,
                error: isValid ? "" : t("validation.emailInvalidFormat")
            };
        };

        // ✅ Imposta i validatori sui campi email
        validation.setValidatorOnInput("SoggettoEmail", emailValidator);
        validation.setValidatorOnInput("SoggettoPec", emailValidator);

        // ✅ Validazione al submit
        this.onSubmitValidator = async () => {
            validation.validate("SoggettoEmail", emailValidator);
            validation.validate("SoggettoPec", emailValidator);
        };

    }

    private onSubmitValidator: () => void = async () => {
    }

    private async handleFormSubmit(): Promise<void> {

        this.onSubmitValidator();
        // Rimuovi eventuali messaggi di errore precedenti
        $("#SoggettoCodiceFiscale, #SoggettoPartitaIva").removeClass("is-invalid");
        $("#SoggettoCodiceFiscale, #SoggettoPartitaIva").siblings(".invalid-feedback").addClass("d-none");
        $("#cf-piva-required").remove();
        $(this.theForm).find(".is-invalid").removeClass("is-invalid");
        $(this.theForm).find(".invalid-feedback").addClass("d-none");

        // Validazione centralizzata di tutti i campi obbligatori
        $(this.theForm)
            .find("input, select, textarea")
            .each(function () {
                const $el = $(this);
                // Salta i campi disabilitati o nascosti
                if ($el.is(":disabled") || !$el.is(":visible")) return;
                // Salta i radio perché gestiti a parte
                if ($el.is(":radio")) return;
                if ($el.prop("required") && !$el.val()) {
                    $el.addClass("is-invalid");
                    $el.siblings(".invalid-feedback").removeClass("d-none");
                }
            });

        // ✅ Validazione custom per i campi autocomplete
        // Controlla che se l'utente ha digitato nel campo comune nascita, abbia anche selezionato un valore
        const txtComuneNascita = $("#txtComuneNascitaCompr");
        const idComuneNascita = $("#SoggettoIdComuneNascita");
        if (txtComuneNascita.is(":visible") && !txtComuneNascita.is(":disabled") && txtComuneNascita.attr("required")) {
            if (txtComuneNascita.val() && !idComuneNascita.val()) {
                txtComuneNascita.val("");
                txtComuneNascita.addClass("is-invalid");
                const errorMsg = txtComuneNascita.siblings(".invalid-feedback");
                if (errorMsg.length === 0) {
                    txtComuneNascita.after(`<div class="invalid-feedback d-block">${t("messages.selezionareComuneDaLista")}</div>`);
                } else {
                    errorMsg.text(t("messages.selezionareComuneDaLista")).removeClass("d-none").addClass("d-block");
                }
            }
        }

        // Controlla che se l'utente ha digitato nel campo comune residenza, abbia anche selezionato un valore
        const txtComuneResidenza = $("#txtComuneCompr");
        const idComuneResidenza = $("#SoggettoIdComuneResidenza");
        if (txtComuneResidenza.is(":visible") && !txtComuneResidenza.is(":disabled") && txtComuneResidenza.attr("required")) {
            if (txtComuneResidenza.val() && !idComuneResidenza.val()) {
                txtComuneResidenza.val("");
                txtComuneResidenza.addClass("is-invalid");
                const errorMsg = txtComuneResidenza.siblings(".invalid-feedback");
                if (errorMsg.length === 0) {
                    txtComuneResidenza.after(`<div class="invalid-feedback d-block">${t("messages.selezionareComuneDaLista")}</div>`);
                } else {
                    errorMsg.text(t("messages.selezionareComuneDaLista")).removeClass("d-none").addClass("d-block");
                }
            }
        }

        // Validazione custom: almeno uno tra Codice Fiscale e Partita IVA per persona giuridica
        const isPersonaGiuridica = $("#SoggettoPersonaGiuridica").is(":checked");
        const cf = ($("#SoggettoCodiceFiscale").val() as string || "").trim();
        const piva = ($("#SoggettoPartitaIva").val() as string || "").trim();

        if (isPersonaGiuridica) {
            // Per persona giuridica: almeno uno dei due deve essere compilato
            if (!cf && !piva) {
                $("#SoggettoCodiceFiscale, #SoggettoPartitaIva").addClass("is-invalid");

                // Mostra il messaggio di errore solo una volta dopo Partita IVA
                if ($("#cf-piva-required").length === 0) {
                    $("#SoggettoPartitaIva").after(`<div id="cf-piva-required" class="invalid-feedback d-block">${t("messages.cfOrPivaRequired")}</div>`);
                } else {
                    $("#cf-piva-required").removeClass("d-none").addClass("d-block");
                }
            } else {
                // Se almeno uno è compilato, rimuovi gli errori
                $("#SoggettoCodiceFiscale, #SoggettoPartitaIva").removeClass("is-invalid");
                if (!cf)
                    $("#SoggettoCodiceFiscale").removeAttr("required");

                if (!piva)
                    $("#SoggettoPartitaIva").removeAttr("required");


                $("#cf-piva-required").remove();
            }
        } else if (!cf) {
            // Per persona fisica, Codice Fiscale obbligatorio
            $("#SoggettoCodiceFiscale").addClass("is-invalid");
            $("#SoggettoCodiceFiscale").siblings(".invalid-feedback").removeClass("d-none");
        }


        $("#cf-format-error").remove();
        if (cf && !isPersonaGiuridica) {
            const cfValidation = validateCodiceFiscale(cf);
            if (!cfValidation.ok) {
                $("#SoggettoCodiceFiscale").addClass("is-invalid");
                $("#SoggettoCodiceFiscale").after(`<div id="cf-format-error" class="invalid-feedback d-block">Formato codice fiscale non valido</div>`);
                return;
            }
        }

        // Se arrivi qui, la validazione custom è ok: puoi lasciare che la validazione HTML5 prosegua per gli altri campi

        if (!this.theForm.checkValidity()) {

            this.theForm.classList.add('was-validated');

            //Elenca i campi richiesti duramente la validazione del FORM
            //TODO: da commentare in seguito
            const invalidFields: string[] = [];
            const form = document.getElementById("frmSoggettoVenditaAcquisto") as HTMLFormElement;

            Array.from(form.elements).forEach((el) => {
                if (el instanceof HTMLInputElement || el instanceof HTMLSelectElement || el instanceof HTMLTextAreaElement) {
                    if (!el.validity.valid) {
                        invalidFields.push(el.name || el.id);
                    }
                }
            });

            console.log("Campi non validi:", invalidFields);
            return;
        }

        const formData = new FormData(this.theForm);
        const formValues: Record<string, string> = this.extractFormValues(formData);
        const idSoggetto = formValues["Id"] ? parseInt(formValues["Id"]) : 0;

        let allegatoGaraId: any = null;
        try {
            //controllo se è presente il file da salvare
            const fileInput = document.getElementById("SoggettoFileDocumento");
            if (fileInput && fileInput instanceof HTMLInputElement && fileInput.files && fileInput.files.length > 0) {
                // ✅ Salvataggio dell'allegato del soggetto
                const resultAll: any = await this.salvaDocumento();
                // ✅ Controlla se il salvataggio è fallito
                if (!resultAll.success) {
                    console.error("Errore durante il salvataggio dell'allegato:", resultAll);
                    // ✅ Estrai il messaggio (supporta sia JSON che stringa semplice)
                    let errorMessage = t("messages.errorUploadingFile");

                    try {
                        const errorData = typeof resultAll.message === "string"
                            ? JSON.parse(resultAll.message)
                            : resultAll.message;
                        errorMessage = errorData?.Message || resultAll.message || errorMessage;
                    } catch {
                        errorMessage = resultAll.message || errorMessage;
                    }

                    UI.confirmOneButton("", errorMessage);
                    return;
                }

                allegatoGaraId = resultAll.data.Allegato.Id;
                formValues["AllegatoGaraId"] = allegatoGaraId;
            } else {
                // L'elemento non esiste o non è un input
                console.warn("Elemento #SoggettoFileDocumento non trovato o non è un input");
            }

            //2-salvataggio del soggetto di vendita/acquisto passandogli l'id dell'allegato
            const result = await this.salvaSoggettoVenditaAcquisto(formValues);

            if (!result) {
                UI.confirmOneButton("", t("messages.errorSavingSoggetto"));
                return;
            }

            this.closeModal();

            try {
                if (idSoggetto > 0) {
                    this.upsertSoggettoVenditaAcquistoUI(result, true);
                } else {
                    this.upsertSoggettoVenditaAcquistoUI(result, false);
                }

                // ✅ Triggera l'evento dopo aver aggiornato la UI
                $(document).trigger("soggettoAggiunto");

            } catch (error) {
                console.error("Errore durante l'aggiornamento dell'interfaccia:", error);
            }


        } catch (error) {
            //cancellazione dell'allegato in caso di errore
            if (allegatoGaraId != null && allegatoGaraId > 0) {
                try {
                    await DeleteDocumentoGara(allegatoGaraId);
                    console.info("Allegato cancellato con successo");
                } catch (error) {
                    console.error("Errore durante la cancellazione dell'allegato:", error);
                }
            }
            // Gestione dell'errore di salvataggio del soggetto
            UI.confirmOneButton("", t("messages.errorSaving"));
        }
    }

    private extractFormValues(formData: FormData): Record<string, string> {
        const formValues: Record<string, string> = {};
        formData.forEach((value, key) => {
            formValues[key] = value.toString();
        });

        // Input di tipo "date" restituisce già il formato yyyy-MM-dd
        // Non serve conversione per DataNascita

        const selectedRadio = document.querySelector('input[name="PersonaGiuridica"]:checked') as HTMLInputElement;

        if (selectedRadio) {
            formValues["PersonaGiuridica"] = selectedRadio.value;
        }

        formValues["OffertaId"] = $("#hdOffertaId").val() as string;
        return formValues;
    }

    private async salvaDocumento(): Promise<any> {
        const fileInput = document.getElementById("SoggettoFileDocumento") as HTMLInputElement;
        if (fileInput?.files?.length) {

            const file = fileInput.files[0];
            const maxSize = 4 * 1024 * 1024; // 4 MB in bytes

            // ✅ Controllo dimensione file
            if (file.size > maxSize) {
                // Mostra errore sotto l'input
                this.showFileError(fileInput, `${t("messages.fileTooLargeSize")} ${this.formatFileSize(file.size)}`);
                return {
                    success: false,
                    message: t("messages.fileTooLargeSize")
                };
            }

            // ✅ Rimuovi eventuali errori precedenti
            this.clearFileError(fileInput);
            const offertaIdValue = $("#SoggettoOffertaId").val() as string;
            const atIdValue = $("#SoggettoIdAstaTelematica").val() as string;
            const offertaId = Number(offertaIdValue) || 0;
            const atId = Number(atIdValue) || 0;

            const nome = $("#SoggettoNome").val() as string;
            const cognome = $("#SoggettoCognome").val() as string;
            const denominazione = $("#SoggettoDenominazione").val() as string;
            const descrizione = denominazione || `${nome} ${cognome}`.trim() || "";

            const data = {
                UserId: this.userinfo.anagraficaId,
                VenditaId: Number($("#hdVenditaId").val()) || 0,
                Tipo: $("#SoggettoTipoDocumento").val() as string,
                OffertaId: offertaId,
                AstaId: atId,
                file: fileInput.files[0],
                Descrizione: descrizione
            };

            try {
                const allegatoGara: any = await uploadDocumentoGara(data);

                return allegatoGara;

            } catch (e) {
                return { success: false, message: "Errore durante il caricamento del documento " + e };
            }

        } else {
            //siamo in caso di modifica dei soli campi del soggetto
            return { success: true }
        }
    }

    private upsertSoggettoVenditaAcquistoUI(data: any, isUpdate: boolean): void {
        const container = document.getElementById("divElencoSoggettiVenditaAcquisto");
        if (!container) return;

        if (isUpdate) {
            const existing = container.querySelector(`.soggetto-item[id="${data.Id}"]`);
            if (existing) existing.remove();
        }

        container.insertAdjacentHTML("beforeend", this.buildSoggettoHtml(data));
    }

    private buildSoggettoHtml(data: any): string {
        const id = data.Id;
        const denominazione = data.PersonaGiuridica ? data.Denominazione : `${data.Nome} ${data.Cognome}`;
        const codiceFiscale = data.PartitaIva || data.CodiceFiscale || "";
        const labelCFPiva = data.PartitaIva ? t("common.partitaIva") : t("common.codiceFiscale");
        const visCFPiva = (data.PartitaIva || data.CodiceFiscale) ? "d-block" : "d-none";
        const pathAllegato = data.AllegatoGara ? data.AllegatoGara.Path : "";
        const nomeDoc = data.AllegatoGara ? data.AllegatoGara.Descrizione : "";

        return `
              <div class="border rounded bg-secondary-subtle pt-2 pb-1 mb-3 position-relative overflow-hidden soggetto-item" id="${id}">
                <div class="bg-white rounded shadow-sm position-relative">
                  <div class="position-absolute z-1 end-0 top-0 d-flex flex-row justify-content-between align-items-center">
                    <a href="#" class="p-2 py-1 py-xl-2 update-soggetto" aria-label="Modifica soggetto" title="Modifica soggetto"
                       data-id="${id}" data-modalitaid="${this._modalitaAcquisto}">
                      <span class="material-symbols-outlined md-18">edit</span>
                    </a>
                    <a href="#" class="p-2 py-1 py-xl-2 delete-soggetto" aria-label="Elimina" title="Elimina" data-id="${id}">
                      <span class="material-symbols-outlined md-18">delete</span>
                    </a>
                  </div>
                  <div class="border-bottom border-sm-bottom-0 border-sm-end p-4 flex-grow-1 position-relative overflow-hidden">
                    <div class="d-flex">
                      <h2 class="h6 fw-bold mb-2">${denominazione}</h2>
                    </div>
                    <div class="small ${visCFPiva}">
                      <strong>${labelCFPiva}:</strong> ${codiceFiscale}
                    </div>
                    <div class="d-flex align-items-center gap-1">
                      <strong>${nomeDoc}</strong>
                      <a href="/Asta/ScaricaDocumentoGara?data=${pathAllegato}&nomeDoc=${nomeDoc}" target="_blank" class="text-body">
                        <span class="material-symbols-outlined">download</span>
                      </a>
                    </div>
                  </div>
                </div>
              </div>`;
    }


    private closeModal(): void {
        const modalElement = document.getElementById('modalSoggettoVenditaAcquisto') as HTMLDivElement;
        const modalInstance = bootstrap.Modal.getInstance(modalElement) || new bootstrap.Modal(modalElement);
        const formElement = modalElement.querySelector("form") as HTMLFormElement;
        this.resetForm(formElement)
        modalInstance.hide();
    }

    private async aggiornaDatiDaCodiceFiscale(codiceFiscale: string): Promise<void> {
        const cf = codiceFiscale.toUpperCase().trim();
        const $input = $("#SoggettoCodiceFiscale");

        // Rimuovi errori precedenti
        $input.removeClass("is-invalid");
        $("#cf-format-error").remove();

        const isValid = validateCodiceFiscale(cf);
        if (!isValid.ok) {
            // ✅ Mostra errore inline sotto il campo
            $input.addClass("is-invalid");
            $input.after(`<div id="cf-format-error" class="invalid-feedback d-block">Formato codice fiscale non valido</div>`);
            return;
        }

        // CF valido: estrai i dati
        const birthDate = extractBirth(cf);
        const dataNascita = birthDate ? format(new Date(birthDate.date), 'yyyy-MM-dd') : "";

        $("#SoggettoDataNascita").val(dataNascita);

        const codePlace: string = cf.slice(11, 15);
        const idStatoNascita = await this.GetStatoIdByCode(codePlace);
        $("#ddlStatoNascCompr").val(idStatoNascita).trigger('change');
        $("#SoggettoIdStatoNascita").val(idStatoNascita);
        if (idStatoNascita === 100) {
            // Se lo stato è Italia, cerco il comune
            const comuneData = await this.GetComuneByCode(codePlace);
            if (comuneData) {
                $("#SoggettoIdComuneNascita").val(comuneData[0].IdComune);
                $("#txtComuneNascitaCompr").val(comuneData[0].Comune);
            } else {
                console.log("Comune non trovato per il codice fiscale:", cf);
            }
        }
    }

    private async GetStatoIdByCode(code: string): Promise<number> {
        return new Promise((resolve, reject) => {
            $.ajaxWithCredentials({
                url: window.BaseUrlWebApi + "Istat/GetStatoByCodiceAt?codiceAT=" + code,
                method: 'GET',
            })
                .done(function (data, textStatus, jqXHR) {
                    resolve(data);
                })
                .fail(function (jqXHR, textStatus, errorThrown) {
                    console.log(textStatus);
                    reject({ jqXHR, textStatus, errorThrown });
                })
                .always(function () {
                });
        });
    }

    private async GetComuneByCode(code: string): Promise<any> {
        return new Promise((resolve, reject) => {
            $.ajaxWithCredentials({
                url: window.BaseUrlWebApi + "Istat/GetComuneByCodiceCatastale?search=" + code,
                method: 'GET',
            })
                .done(function (data, textStatus, jqXHR) {
                    resolve(data);
                })
                .fail(function (jqXHR, textStatus, errorThrown) {
                    console.log(textStatus);
                    reject({ jqXHR, textStatus, errorThrown });
                })
                .always(function () {
                });
        });
    }

    private async salvaSoggettoVenditaAcquisto(objData: any): Promise<any> {
        const soggettoId = objData["Id"] ? parseInt(objData["Id"]) : 0;
        const data = {
            Id: soggettoId,
            PraticaId: objData["PraticaId"],
            OffertaId: objData["OffertaId"],
            BustaId: objData["BustaId"],
            QuotaComproprieta: objData["QuotaComproprieta"],
            PersonaGiuridica: objData["PersonaGiuridica"],
            Cognome: objData["Cognome"],
            Nome: objData["Nome"],
            CodiceFiscale: objData["CodiceFiscale"],
            Denominazione: objData["Denominazione"],
            PartitaIva: objData["PartitaIva"],
            CodiceSdi: objData["CodiceSdi"],
            DataNascita: objData["DataNascita"] || null,
            IdStatoNascita: objData["IdStatoNascita"],
            IdComuneNascita: objData["IdComuneNascita"],
            LuogoNascitaEstero: objData["LuogoNascitaEstero"],
            IdStatoResidenza: objData["IdStatoResidenza"],
            IndirizzoResidenza: objData["IndirizzoResidenza"],
            IdComuneResidenza: objData["IdComuneResidenza"],
            CapResidenza: objData["CapResidenza"],
            IdProvinciaResidenza: objData["IdProvinciaResidenza"],
            LuogoResidenzaEstero: objData["LuogoResidenzaEstero"],
            Email: objData["Email"],
            Telefono: objData["Telefono"],
            Pec: objData["Pec"],
            AllegatoGaraId: objData["AllegatoGaraId"],
        }
        console.log("data: ", data);
        let url = "";
        if (soggettoId) {
            url = window.BaseUrlWebApi + "SoggettoVenditaAcquisto/Update";
        } else {
            url = window.BaseUrlWebApi + "SoggettoVenditaAcquisto/Insert";
        }
        try {
            const response = await this.auth.fetchWithAuth("POST " + url, {
                headers: { "Content-Type": "application/json" },
                body: JSON.stringify(data),
            });

            return response;
        } catch (error) {
            console.info("Errore durante il salvataggio:", error);
            return;
        }
    }

    private async deleteSoggettoVenditaAcquisto(id: number): Promise<any> {
        var url = window.BaseUrlWebApi + "SoggettoVenditaAcquisto/Delete?id=" + id;
        try {
            const response = await this.auth.fetchWithAuth("DELETE " + url, {
                cache: "no-cache",
                headers: { 'content-type': 'application/json' },
            });
            if (!response.success) {
                const errorText = await response.message();
                throw new Error(`Errore durante la cancellazione: ${errorText}`);
            }

            console.log("Soggetto cancellato con successo.");
            return true;

        } catch (error) {
            console.info("Errore durante la cancellazione del soggetto:", error);
            return;
        }
    }

    private async resetAllegatoGaraid(soggettoId: number): Promise<void> {
        var url = window.BaseUrlWebApi + "SoggettoVenditaAcquisto/ResetAllegatoGaraId?id=" + soggettoId;
        try {
            const response = await this.auth.fetchWithAuth("POST " + url, {
                cache: "no-cache",
                headers: { 'content-type': 'application/json' },
            });

            if (!response.success) {
                const errorText = await response.message();
                throw new Error(`Errore durante l'aggiornamento del soggetto: ${errorText}`);
            }
        } catch (error) {
            console.info("Errore durante l'aggiornamento del soggetto:", error);
            return;
        }
    }

    // ✅ Metodo helper per mostrare l'errore
    private showFileError(fileInput: HTMLInputElement, message: string): void {
        // Aggiungi classe di errore all'input
        $(fileInput).addClass("is-invalid");

        // Cerca se esiste già un elemento per l'errore
        let errorElement = $(fileInput).siblings(".invalid-feedback");

        if (errorElement.length === 0) {
            // Crea l'elemento per l'errore se non esiste
            $(fileInput).after(`<div class="invalid-feedback d-block">${message}</div>`);
        } else {
            // Aggiorna il messaggio esistente
            errorElement.text(message).removeClass("d-none").addClass("d-block");
        }
    }

    // ✅ Metodo helper per rimuovere l'errore
    private clearFileError(fileInput: HTMLInputElement): void {
        $(fileInput).removeClass("is-invalid");
        $(fileInput).siblings(".invalid-feedback").addClass("d-none").removeClass("d-block");
    }

    // ✅ Metodo helper per formattare la dimensione del file
    private formatFileSize(bytes: number): string {
        if (bytes === 0) return '0 Bytes';

        const k = 1024;
        const sizes = ['Bytes', 'KB', 'MB', 'GB'];
        const i = Math.floor(Math.log(bytes) / Math.log(k));

        return Math.round((bytes / Math.pow(k, i)) * 100) / 100 + ' ' + sizes[i];
    }

}

export default SoggettoVenditaAcquistoModal;